import { useState, useEffect } from "react";

const useFetchProducts = (productId = null) => {
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("https://inaaniserver-50c4305cc7f7.herokuapp.com/products/getAll");
        if (!response.ok) throw new Error(`Failed to fetch products. Status: ${response.status}`);

        const data = await response.json();

        if (!data.status) throw new Error("Failed to fetch products");

        if (productId !== null) {
          const selectedProduct = data.data.find((prod) => prod.id === parseInt(productId));
          if (!selectedProduct) throw new Error("Product not found.");
          setProduct(selectedProduct);
        }

        const filteredProducts = data.data.filter((prod) => prod.id !== parseInt(productId));
        setProducts(filteredProducts);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [productId]);

  return { product, products, loading, error };
};

export default useFetchProducts;
